import { hexToHsl } from '@/lib/utils';

/**
 * Os campos de marca que o app pinta no documento. Sao os mesmos de
 * `core.tenants` que `GET /public/tenant/resolve` devolve e que o bloco
 * `company` de `PATCH /crm/settings` grava.
 */
export interface TenantBranding {
  appName?: string | null;
  faviconUrl?: string | null;
  primaryColor?: string | null;
  accentColor?: string | null;
}

/**
 * Aplica a marca do tenant ao documento: titulo, favicon e as custom properties
 * que o Tailwind consome (`--primary` em HSL, mais os hex crus).
 *
 * Extraida do `TenantProvider` para ter DOIS chamadores com o mesmo
 * comportamento: a resolucao inicial do tenant e o salvamento em
 * "Marca e aparencia". Sem isso, salvar a cor so a aplicaria no F5 seguinte —
 * a tela diria "salvo" e o app continuaria na cor antiga, que e' a versao
 * educada de "salvou nada".
 *
 * Campo ausente/`null` = "o tenant nao define" e NAO e' o mesmo que "voltar ao
 * padrao": quem apaga a cor recebe `null` do servidor, e ai a propriedade e'
 * REMOVIDA para o `:root` do CSS voltar a valer. Deixar o valor antigo no DOM
 * mostraria a cor apagada ate o proximo reload.
 */
export function applyTenantBranding(brand: TenantBranding): void {
  if (typeof document === 'undefined') return;

  const root = document.documentElement;

  if (brand.appName) {
    document.title = brand.appName;
  }

  if (brand.faviconUrl) {
    const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
    if (link) link.href = brand.faviconUrl;
  }

  if (brand.primaryColor) {
    root.style.setProperty('--primary-color', brand.primaryColor);
    root.style.setProperty('--primary', hexToHsl(brand.primaryColor));
  } else if (brand.primaryColor === null) {
    root.style.removeProperty('--primary-color');
    root.style.removeProperty('--primary');
  }

  if (brand.accentColor) {
    root.style.setProperty('--accent-color', brand.accentColor);
  } else if (brand.accentColor === null) {
    root.style.removeProperty('--accent-color');
  }
}
